<template>
  <!-- 添加或修改业务对话框 -->
  <el-dialog :title="title" :visible.sync="open" width="800px" hieght="500px" :close-on-click-modal="false" append-to-body>
    <el-form ref="bizform" :model="bizform" label-width="80px">
      <!-- <div class="item-container">
            <div class="item" v-for="(value, index) in dataItems" :key="index">
                <img id="imgPic" :src="value.filePathUrl"  title="点击查看"
                style="width: 120px;height: 100px;" />
            </div>
            </div> -->
      <div class="wrap">
      <el-button @click="showImgViewer" >预览图片</el-button>
      <el-image-viewer
        v-if="imgViewerVisible"
        :initial-index="1"
        :on-close="closeImgViewer"
        :url-list="dataItems" >
      </el-image-viewer>
    </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">下载</el-button>
      <el-button @click="cancel">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import BarChart from '@/components/wms/barChart'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getCFSInboundPicDataApi, getCFSOutboundPicDataApi, getCFSDownLoadPicDataApi, getCFSCTNPicDataApi } from '@/api/wms'
export default {
  components: {
    BarChart,
    ElImageViewer
  },
  props: {
    bizType: {
      type: String,
      default: ''
    },
    consignOrderNo: {
      type: String,
      default: ''
    }
  },
  name: 'selectFilePic',
  data() {
    return {
      searchForm: {
        type: this.bizType,
        consignOrderNo: this.consignOrderNo,
        billNo: '',
        ctnNo: '',
      },
      imgViewerVisible: false,
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 表单参数
      bizform: {},
      dataItems: [],
      imgList: [
        'https://img1.baidu.com/it/u=3302184040,3713353210&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1703264400&t=3f1afc0ae003d28cbbc3709fc277db90',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ]
    };
  },
  methods: {
    // 窗口初始化方法，nextTick方法可以添加逻辑，如打开窗口时查询数据填充
    async init(billNo, bizId, type) {
      console.log(type);
      this.open = true;
      this.searchForm.consignOrderNo = bizId;
      this.searchForm.ctnNo = bizId;
      this.searchForm.billNo = billNo;
      const params = this.searchForm
      if (type == 'CFSInbound') {
        var res = await getCFSInboundPicDataApi(params)
        if (res && res.code == 200) {
          var data = res.data;
          this.dataItems = data;
          console.log(res.code);
        }
      } else if (type == 'CFSCTN') {
        var rese = await getCFSCTNPicDataApi(params)
        if (rese && rese.code == 200) {
          var data1 = rese.data;
          this.dataItems = data1;
        }
      } else {
        var rese1 = await getCFSOutboundPicDataApi(params)
        if (rese1 && rese1.code == 200) {
          var data2 = rese1.data;
          this.dataItems = data2;
        }
      }
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    async submitForm () {
      const params = this.searchForm
      var res = await getCFSDownLoadPicDataApi(params)
      console.log(res);
      if (res && res.code == 200) {
        var data = res.data;
        window.location.href = data;
        this.open = false;
        this.reset();
      }
      // window.open(data, '_self');
      // var res = await getCFSInboundPicDataApi(params);
      // var data = data.data;
      // window.open(data, "_self");
    },
    showImgViewer() {
      this.imgViewerVisible = true;
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', m, false); // 禁止页面滑动

    },
    closeImgViewer() {
      this.imgViewerVisible = false;
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'auto';
      document.removeEventListener('touchmove', m, true);
    },
  }
};

</script>
<style scoped>

.order-search {
    margin-top: 10px;
    background: white;
    border-radius: 4px;
    padding: 10px 10px;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 10px 10px;
  }
  .order-list .list-item {
      margin-bottom:8px;
    }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #9c9c9c;
    line-height: 22px;
    margin-bottom: 10px;
  }

</style>
<style>
.el-select ,.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}
.tms-style .el-input__inner{
  max-width: none;
}
.el-loading-mask{
  z-index: 1000;
}
.item-container {
  display: flex;
  flex-wrap: wrap;
}
.item {
  width: 150px;
  height: 120px;

  line-height: 120px;
}
</style>
